import ResultCard from '@component/ResultCard'
import { useTranslation } from 'react-i18next'
import { useTwoWaySlab } from './context'

function TwoWaySlabResult () {
  const { t } = useTranslation()

  const { form, result } = useTwoWaySlab()

  const hidden = !form.formState.isSubmitSuccessful

  return (
    <ResultCard
      title={t('COMPOUND.RESULT', { label: 'GLOSSARY.SLAB' })}
      unit="mm"
      label={t('GLOSSARY.MIN_REQUIRED_THICKNESS')}
      result={Number(result?.toFixed(0))}
      hidden={hidden}
    />
  )
}

export default TwoWaySlabResult
